/**
 * Styling Settings Component
 *
 * Displays styling options for the shipping bar.
 * Single Responsibility: Render styling settings section
 */
import { Paper, Stack, Title, Text, Select, ColorInput, Divider, Group, Button } from '@mantine/core';
import { LAYOUT_STYLE_OPTIONS } from '../../constants/freeShippingBarDefaults';
import { LivePreview } from './LivePreview';

export const StylingSettings = ({ settings, onSettingsChange, onSave, loading }) => {
  return (
    <Paper shadow="sm" p="xl" radius="md" withBorder>
      <Stack gap="lg">
        <div>
          <Title order={3} mb="xs">Styling</Title>
          <Text size="sm" c="dimmed">
            Customize the appearance of the shipping bar
          </Text>
        </div>

        <Divider />

        <Select
          label="Layout Style"
          description="Choose a visual style for the progress bar"
          value={settings.layout_style}
          onChange={(value) => onSettingsChange({ ...settings, layout_style: value })}
          data={LAYOUT_STYLE_OPTIONS}
          style={{ maxWidth: 400 }}
        />

        <ColorInput
          label="Progress Bar Color"
          description="Color of the progress bar fill"
          value={settings.bar_color}
          onChange={(value) => onSettingsChange({ ...settings, bar_color: value })}
          format="hex"
          style={{ maxWidth: 400 }}
        />

        <ColorInput
          label="Text Color"
          description="Color of the text"
          value={settings.text_color}
          onChange={(value) => onSettingsChange({ ...settings, text_color: value })}
          format="hex"
          style={{ maxWidth: 400 }}
        />

        <ColorInput
          label="Background Color"
          description="Background color of the bar"
          value={settings.bg_color}
          onChange={(value) => onSettingsChange({ ...settings, bg_color: value })}
          format="hex"
          style={{ maxWidth: 400 }}
        />

        <Divider />

        <LivePreview settings={settings} />

        <Group justify="flex-end" mt="md">
          <Button
            size="md"
            onClick={onSave}
            loading={loading}
          >
            Save Changes
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
};
